export const OAUTH_CALLBACK_PATH = '/auth/callback';

const OAUTH_CALLBACK_PARAMS = Object.freeze([
  'code',
  'state',
  'error',
  'error_description',
  'error_uri',
]);

/**
 * Cognito returns `state` with either an authorization code or a provider
 * error. Requiring state avoids treating unrelated `?code=` query parameters
 * elsewhere in the app as authentication callbacks.
 */
export function hasOAuthCallbackResponse(search = '') {
  try {
    const params = new URLSearchParams(search);
    return params.has('state') && (params.has('code') || params.has('error'));
  } catch {
    return false;
  }
}

/** Remove one-use OAuth data before keeping or reusing an application URL. */
export function removeOAuthCallbackParams(params) {
  for (const name of OAUTH_CALLBACK_PARAMS) params.delete(name);
  return params;
}

/**
 * Forward a callback delivered to a legacy allowlisted route into the
 * dedicated callback document. The one-use code is moved, never copied into
 * storage or logs.
 */
export function buildOAuthCallbackForwardPath(locationLike = window.location) {
  return `${OAUTH_CALLBACK_PATH}${locationLike.search || ''}${locationLike.hash || ''}`;
}

export const OAUTH_CALLBACK_PARAM_NAMES = OAUTH_CALLBACK_PARAMS;
